import { render } from "./EditLiquidation5.vue?vue&type=template&id=570b82e0"
import script from "./EditLiquidation5.vue?vue&type=script&lang=js"
export * from "./EditLiquidation5.vue?vue&type=script&lang=js"

import "./EditLiquidation5.vue?vue&type=style&index=0&id=570b82e0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__